import React from 'react';
import PropTypes from 'prop-types';

import { Col, Image } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

import Button from 'app/components/Button';

import 'app/components/MarketplaceConnectorList/MarketplaceConnectorListCard.scss';
import { Colors } from 'app/utils/colors';
import Icon from '../Icon';

export default function MarketplaceConnectorListCard({
  image = null,
  mainText = null,
  status = null,
  id,
  isBlackFridayActive = false,
  isChristmasActive = false
}) {
  const intl = useIntl();

  const conectorPurchased = status === 'ACTIVE' || status === 'PURCHASED';

  const onClickButton = () => {
    window.open(
      `${process.env.REACT_APP_BIGBUY_URL}subscription/checkout?serviceProductId=${id}`,
      '_blank'
    );
  };
  return (
    <Col xs={6} md={4} lg={3} className="connector-list-card">
      <div
        className={classNames('connector-list-card_container', {
          active: conectorPurchased
        })}
      >
        {isBlackFridayActive && (
          <div className="connector-list-card_container__black-friday-badge">
            <p className="connector-list-card_container__black-friday-badge__text">
              50% OFF
            </p>
          </div>
        )}
        {isChristmasActive && (
          <div className="connector-list-card_container__christmas-badge">
            <p className="connector-list-card_container__christmas-badge__text">
              50% OFF
            </p>
          </div>
        )}
        <div className="connector-list-card_container__info">
          {image && (
            <div className="connector-list-card_container__image">
              <Image src={image} />
            </div>
          )}
          {mainText && (
            <p className="bold connector-list-card_container__name">
              {mainText}
            </p>
          )}
        </div>

        {conectorPurchased ? (
          <div className="connector-list-card_container__date">
            <p className="medium">
              {status === 'ACTIVE' &&
                intl.formatMessage({ id: 'controlpanel.global.active' })}
              {status === 'PURCHASED' &&
                intl.formatMessage({ id: 'controlpanel.global.purchased' })}
            </p>
            <Button
              size="small"
              icon={<Icon icon="shopping-cart" color={Colors.bbSecondary} />}
              svg="/media/svg/bigbuy/medium/shopping-cart.svg"
              onClick={onClickButton}
            />
          </div>
        ) : (
          <div className="connector-list-card_container__button">
            <Button
              size="small"
              text={intl.formatMessage({
                id: 'controlpanel.marketplace_connector_card.buy'
              })}
              svg="/media/svg/bigbuy/medium/shopping-cart.svg"
              onClick={onClickButton}
            />
          </div>
        )}
      </div>
    </Col>
  );
}

MarketplaceConnectorListCard.propTypes = {
  id: PropTypes.string.isRequired,
  image: PropTypes.string,
  mainText: PropTypes.string,
  isBlackFridayActive: PropTypes.bool,
  isChristmasActive: PropTypes.bool,
  status: PropTypes.string
};
